import { sendAnalyticsEvent, UnknownEvent } from '@faststore/sdk'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'

export const TopCategorySection = () => {
  const { topCategory } = useGlobalNavigation()

  const handleAnalytics = (label: string) => {
    if (!label) return

    sendAnalyticsEvent<UnknownEvent>({
      name: 'menu_categorie',
      params: {
        path: '',
        section: 'hamb_menu',
        main_category: label,
      },
    })
  }

  return (
    <div className="bg-[#F7F5F5] px-6 pb-6 pt-4 border-t-4 border-solid border-[#F0F0F0] [&amp;>a:last-child]:mb-0">
      {topCategory.map((el, index: number) => (
        <a
          key={`top-category-el-${index}`}
          href={el?.titleURL}
          className="py-2 flex flex-row gap-3 items-center justify-between mb-1 no-underline"
          onClick={() => handleAnalytics(el?.title)}
        >
          <div className="flex flex-row gap-2 items-center max-w-[calc(100%-36px)]">
            <div className="block w-6 h-6 min-w-[24px] min-h-[24px]">
              <img
                className="max-w-full"
                src={el?.logoImage}
                alt={`img-${el?.title}`}
              />
            </div>
            <div className="max-w-full overflow-hidden">
              <span className="block text-sm font-semibold tracking-[0.035px] text-[#232323]">
                {el.title}
              </span>
            </div>
          </div>
        </a>
      ))}
    </div>
  )
}
